module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/modules/_library.js
// module id = 49
// module chunks = 0